import base from './base'

export default {
  ...base,
  colors: {
    ...base.colors,
    shadow1: '#f98435',
    text1: '#f98435',
    text2: '#f98435',
    text3: '#888D9B',
    text4: '#f98435',

    // backgrounds / greys
    bg0: 'black',
    bg1: 'black',
    bg2: 'black',
    bg3: 'black',
    bg4: '#fff',
    bg5: '#f98435',
    modalBG: 'rgba(0,0,0,0.3)',
    advancedBG: '#f98435',

    //primary colors
    primary1: '#f98435',
    primary4: '#f98435',
    primary5: '#f98435',

    // color text
    primaryText1: 'black',
    buttonText: 'black',

    // secondary colors
    secondary1: '#fff'
  }
}
